import { useEffect } from "react";
import { useStoreSelector } from "../../../../src/lib/store";
import { uiStore } from "../store/uiStore";

/** Full-screen bounce / stems progress. Driven by `uiStore.bounce`. */
export function BounceOverlay() {
  const bounce = useStoreSelector(uiStore, s => s.bounce);
  const pct = Math.round(Math.max(0, Math.min(1, bounce.progress)) * 100);

  useEffect(() => {
    document.body.classList.toggle("lab-bouncing", bounce.active);
    return () => {
      document.body.classList.remove("lab-bouncing");
    };
  }, [bounce.active]);

  if (!bounce.active) {
    return null;
  }

  return (
    <div
      id="bounce-overlay"
      className="pointer-events-auto fixed inset-0 z-[80] flex items-center justify-center bg-[rgba(8,10,14,0.62)] backdrop-blur-[2px]"
      aria-live="polite"
      aria-busy={true}
    >
      <div className="w-[min(360px,calc(100vw-32px))] rounded-lg border border-lab-line bg-lab-panel px-[1.1rem] py-4 shadow-[0_24px_48px_rgba(0,0,0,0.5)]">
        <div className="mb-[0.7rem] font-semibold text-slate-100">{bounce.title}</div>
        <div className="h-2 overflow-hidden rounded-full bg-white/[0.08]" aria-hidden={true}>
          <div
            className="h-full rounded-full bg-gradient-to-r from-lab-accent to-sky-300 transition-[width] duration-75 linear"
            style={{ width: `${pct}%` }}
          />
        </div>
        <div className="mt-[0.55rem] font-mono text-[12px] text-lab-muted tabular-nums">{pct}%</div>
      </div>
    </div>
  );
}
